<template>
  <keep-alive>
    <component :is="componentSelected" :detail="custDetail" :custDetail="custDetail" :isLoading="isLoading" :typeRequest="typeRequest" />
  </keep-alive>
</template>

<script>
import DetailsAirOcean from './DetailsAirOcean.vue'
import DetailsLand from './DetailsLand.vue'

export default {
  name: 'Details',
  components: {
    DetailsAirOcean,
    DetailsLand
  },
  props: {
    typeRequest: String,
    custDetail: Object,
    isLoading: Boolean
  },
  computed: {
    componentSelected () {
      if (this.custDetail && this.custDetail.service_head === 'LAND') {
        return DetailsLand
      }
      return DetailsAirOcean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/Details.vue